<template>
  <div class="form3">
    <div class="content1">
      <van-cell-group>
        <van-field label="身份证号" placeholder="请填写身份证号码" v-model="ID_CARD" />
        <van-field label="验证码" placeholder="请填写验证码" v-model="CODE">
          <van-button slot="button" size="small" type="primary" @click="sendVerifyCode" :disabled="sendVerifyDisabled"
            v-text="verifyText"></van-button>
        </van-field>
      </van-cell-group>
    </div>
    <div class="btndiv">
      <button type="button" class="search">查询</button>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        ID_CARD: '',
        CODE: '',
        REAL_CODE: '',
        REGISTER: false,
        DATA: {
          currentCustomerName: '',
          currentCustomerId: ''
        },
        sendVerifyDisabled: false,
        verifyText: '发送验证码',
        verifySecond: 60,
        timer: null
      }
    },
    methods: {
      search() {
        // this.$router.push('/user/yuyueSuccess');
      },
      sendVerifyCode() {}
    },
    created: function () {
      window.scroll(0, 0);
    },
  }

</script>
<style lang="less">
  body {
    background-color: #fff;
  }

  .van-button {
    border-color: #74b13f;
    color: #74b13f;
    background-color: #fff;
    border-radius: 5px;
  }

  .form3 {
    .btndiv {
      text-align: center;
    }

    font-family: 'Arial Normal',
    'Arial';
    font-weight: 400;
    font-style: normal;
    line-height: normal;
    font-size: 14px;
    padding-top: 10px; // input[type="text"] {

    //     width: 90%;
    //     border-width: 1px;
    //     border-style: solid;
    //     border-color: rgba(228, 228, 228, 1);
    //     border-radius: 4px;
    //     height: 2em;
    //     padding-left: 10px;
    // }
    // .content1 {
    //     margin-top: 2rem;
    //     .labyz {
    //         margin-left: 20px;
    //         padding: 5px;
    //         font-size: 8px;
    //         border-color: #aacd06;
    //         color: #aacd06;
    //         background-color: #fff;
    //         border-radius: 5px;
    //     }
    //     .inputyz {
    //         width: 40%;
    //     }
    //     li {
    //         position: relative;
    //         padding: 0 0em 0em 6em;
    //         margin-bottom: 1rem;
    //         height: 2em;
    //     }
    //     span {
    //         display: block;
    //         width: 5em;
    //         position: absolute;
    //         left: 1em;
    //         top: 0.7em;
    //     }
    // }
    .search {
      background-color: #aacd06;
      box-sizing: border-box;
      border: 1px solid #aacd06;
      border-radius: 5px;
      box-shadow: none;
      color: #fff;
      font-size: 0.9rem;
      width: 7rem;
      height: 2.4rem;
      text-align: center;
      margin-top: 3rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/reportSearch.vue